import { Stack, TextField, Typography } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import {
  MAX_BARCODE_LENGTH,
  validateBarcodeStartPosition,
} from '../barcodeRange'
import type { BarcodeSettingForm } from './barcodeSettingForm'

export const StartPosition = () => {
  const { control, getValues, trigger } = useFormContext<BarcodeSettingForm>()

  return (
    <Stack spacing={1}>
      <Typography
        variant="body2"
        sx={{ fontWeight: 'bold', color: 'text.primary' }}
      >
        開始位置
      </Typography>
      <Controller
        name="startPosition"
        control={control}
        rules={{
          required: '必須です',
          min: { value: 1, message: '1以上を入力してください' },
          validate: startPosition =>
            validateBarcodeStartPosition({
              startPosition,
              length: getValues('length'),
            }) ?? true,
        }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            type="number"
            slotProps={{ htmlInput: { max: MAX_BARCODE_LENGTH, min: 1 } }}
            fullWidth
            error={!!error}
            helperText={error?.message}
            sx={{ bgcolor: 'white' }}
            onChange={e => {
              const newValue = Number(e.target.value)
              field.onChange(newValue)
              void trigger(['startPosition', 'length'])
            }}
          />
        )}
      />
    </Stack>
  )
}
